/* eslint-disable no-unused-vars */
export enum LocalRole {
  Admin = "ADMIN",
  Manager = "MANAGER",
  CardOwner = "CARDOWNER",
  Cashier = "CASHIER",
}
